export default "__VITE_PUBLIC_ASSET__7c4f1b57__"